import CreateConsultant from "./CreateConsultant";
import DisplayConsultant from "./DisplayConsultant";
import { Route } from "react-router-dom";

const routes = {
  key: "CONSULTANT",
  routes: ({ userScope }) => {
    return [
      <Route key={"consultant"} path={`${userScope}/consultant`}>
        <Route
          path="creation"
          key={"consultant-creation"}
          element={<CreateConsultant />}
        />
        <Route
          key={"consultant-display"}
          path=":slug"
          element={<DisplayConsultant />}
        />
      </Route>,
    ];
  },
};
export default routes;
